import { Alignment, Navbar, NavbarGroup, NavbarHeading } from '@blueprintjs/core'
import React, { Component, ReactNode } from 'react'
import { Link } from 'react-router-dom'
import { links } from '../../app.links'
import { AspireLogo, HamburgerMenu } from '../../shared'
import './toolbar.scss'

type Props = {
  children: {
    nav: ReactNode
    settings: ReactNode
    feedback?: ReactNode
  }
}

export class Toolbar extends Component<Props> {
  render() {
    const { children } = this.props

    return (
      <Navbar data-test="toolbar">
        <NavbarGroup>
          <NavbarHeading>
            <Link to={links.frontFace.home()}>
              <AspireLogo size="mini" color="color" noClaim />
            </Link>
          </NavbarHeading>
        </NavbarGroup>
        <HamburgerMenu>
          <NavbarGroup>{children.nav}</NavbarGroup>
        </HamburgerMenu>
        <NavbarGroup className="toolbar__user" align={Alignment.RIGHT}>
          {children.settings}
        </NavbarGroup>
        {children.feedback && <NavbarGroup align={Alignment.RIGHT}>{children.feedback}</NavbarGroup>}
      </Navbar>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/toolbar.tsx